import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenanceHistoricoBastidorComponent } from "./maintenance-historico-bastidor.component";
import { MaintenanceHistoricoBastidorListComponent } from "./maintenance-historico-bastidor-list/maintenance-historico-bastidor-list.component";
import { MaintenanceHistoricoBastidorSelectedComponent } from "./maintenance-historico-bastidor-selected/maintenance-historico-bastidor-selected.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";
import { ListFsplacaComponent } from "./placa/list-fsplaca/list-fsplaca.component";
import { DetailFsplacaComponent } from "./placa/detail-fsplaca/detail-fsplaca.component";

const routesHistorialBastidor: Routes = [
  {
    path: "",
    component: MaintenanceHistoricoBastidorComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: MaintenanceHistoricoBastidorListComponent,
      },
      {
        path: "creacion",
        component: MaintenanceHistoricoBastidorSelectedComponent,
        data: {
          operation: "creacion",
        },
      },
      {
        path: "edicion/:id",
        component: MaintenanceHistoricoBastidorSelectedComponent,
        data: {
          operation: "edicion",
        },
      },
    ],
  },
  {
    path: "fsplaca",
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListFsplacaComponent,
      },{
        path: "detalle/:id",
        component: DetailFsplacaComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesHistorialBastidor)],
  exports: [RouterModule],
})
export class MaintenanceHistoricoBastidorRoutingModule {}
